import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEsc: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="esc, power"><path d="M12.75 1.75V1H11.25V1.75H12.75ZM11.25 5.75V6.5H12.75V5.75H11.25ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5V22C17.5228 22 22 17.5228 22 12H20.5ZM12 20.5C7.30558 20.5 3.5 16.6944 3.5 12H2C2 17.5228 6.47715 22 12 22V20.5ZM3.5 12C3.5 8.8076 5.25959 6.02517 7.8654 4.57144L7.1346 3.2615C4.07318 4.96941 2 8.24209 2 12H3.5ZM16.1881 4.60152C18.7645 6.06338 20.5 8.82949 20.5 12H22C22 8.26788 19.9552 5.01432 16.9283 3.2969L16.1881 4.60152ZM11.25 1.75V5.75H12.75V1.75H11.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEsc;
